// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReceiptClaimResponse
 */
export interface IReceiptClaimResponse {
    /**
     * 
     * @type {number}
     * @memberof IReceiptClaimResponse
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptClaimResponse
     */
    current_claim_status?: IReceiptClaimResponseCurrentClaimStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IReceiptClaimResponse
     */
    requested_amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IReceiptClaimResponseCurrentClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IReceiptClaimResponse interface.
 */
export function instanceOfIReceiptClaimResponse(value: object): value is IReceiptClaimResponse {
    return true;
}

export function IReceiptClaimResponseFromJSON(json: any): IReceiptClaimResponse {
    return IReceiptClaimResponseFromJSONTyped(json, false);
}

export function IReceiptClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReceiptClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'current_claim_status': json['current_claim_status'] == null ? undefined : json['current_claim_status'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
    };
}

export function IReceiptClaimResponseToJSON(json: any): IReceiptClaimResponse {
    return IReceiptClaimResponseToJSONTyped(json, false);
}

export function IReceiptClaimResponseToJSONTyped(value?: IReceiptClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'current_claim_status': value['current_claim_status'],
        'requested_amount': value['requested_amount'],
    };
}

